<template>
  <div>
    <b-card class="shadow">
      <div class="row">
        <div class="col-12">
          <div class="d-flex align-items-center justify-content-between mb-4">
            <div>
              <h5 class="mb-3 text-gray-800">
                {{ $t("Todas as Famílias") }}
              </h5>
            </div>

            <b-button-group>
              <b-button
                variant="outline-dark"
                :class="viewFilterReport === true ? 'active' : ''"
                @click="viewFilters"
              >
                <i class="fas fa-filter"></i>
                {{ $t("Filtros") }}
              </b-button>
              <b-button variant="outline-dark" @click="print()">
                <i class="fas fa-print"></i>
              </b-button>
              <b-button
                variant="outline-dark"
                @click="exportar()"
                :title="$t('Exportar')"
                v-b-tooltip.hover
              >
                <i class="fas fa-file-excel"></i>
              </b-button>
            </b-button-group>
          </div>
        </div>

        <div class="col-12" v-if="viewFilterReport">
          <form @submit.prevent="getFamilias" ref="formFiltros">
            <div class="row">
              <div class="col-md-8">
                <label><b>Pesquisar</b></label>
                <div class="input-group">
                  <b-input
                    placeholder="Pesquisar por: ID, Código Cadúnico, Nome Completo ou Endereço"
                    class="form-control search-input"
                    type="text"
                    v-model="search"
                    aria-describedby="input-search"
                    @keydown.enter.prevent="getFamilias"
                  />
                  <div
                    class="input-group-append"
                    role="button"
                    @click.prevent="getFamilias"
                  >
                    <span class="input-group-text" id="input-search"
                      ><i class="fas fa-search search-icon"
                    /></span>
                  </div>
                </div>
                <p class="small text-muted">
                  No campo acima você pode pesquisar por: ID, Código Cadúnico,
                  Nome Completo ou Endereço
                </p>
              </div>

              <form-select
                v-model="filtroOutras"
                grid="4"
                label="Outras Opções"
                :itens="$root.arrays.outras_opcoes_filtro_familia"
              />

              <form-calendar
                v-model="data_inicio"
                grid="4"
                label="Data Inicial"
              />

              <form-calendar
                v-model="data_fim"
                grid="4"
                label="Data Final"
                :required="verificaDataInicial"
              />

              <form-select
                v-model="filtroStatus"
                grid="4"
                label="Estado Cadastral"
                :itens="$root.arrays.estado_cadastral_familia_filtros"
              />

              <form-select
                ref="select"
                grid="6"
                :label="$t('Bairro/Localidade')"
                placeholder="Digite o bairro e aguarde o resultado"
                :itens="localidades"
                v-model="filtroLocalidade"
                @selected="setLocalidade"
                @search="searchLocalidade"
                :loading="loadingLocalidade"
              />

              <form-select
                ref="selectLogradouro"
                grid="6"
                :label="$t('Logradouro')"
                :itens="logradouros"
                v-model="filtroLogradouro"
                :loading="loadingLogradouro"
                placeholder="Digite o nome do logradouro e aguarde"
                :disabled="disableLogradouro"
              />

              <form-select
                v-model="filtroVulnerabilidades"
                label="Vulnerabilidades"
                :itens="vulnerabilidades"
                :disabled="loadingVulnerabilidades"
                :loading="loadingVulnerabilidades"
                :multiple="true"
              />

              <form-toggle
                v-model="showfiltroNomeSocial"
                grid="12"
                label="Filtrar por Nome Social"
              />

              <div class="col-md-8" v-if="showfiltroNomeSocial">
                <label><b>Nome Social</b></label>
                <div class="input-group">
                  <b-input
                    placeholder="Nome Social"
                    class="form-control search-input"
                    type="text"
                    v-model="filtroNomeSocial"
                    aria-describedby="input-search"
                    @keydown.enter.prevent="getFamilias"
                  />
                  <div
                    class="input-group-append"
                    role="button"
                    @click.prevent="getFamilias"
                  >
                    <span class="input-group-text" id="input-search"
                      ><i class="fas fa-search search-icon"
                    /></span>
                  </div>
                </div>
              </div>

              <form-select
                v-if="showfiltroNomeSocial"
                grid="4"
                v-model="filtroOrigemNomeSocial"
                :itens="$root.arrays.origem_nome_social"
                label="Origem do Nome Social"
                multiple
              />
            </div>
            <div class="row pt-2 mb-4 px-0 d-flex justify-content-end">
              <div class="col-auto px-2 text-right">
                <button
                  class="btn btn-default btn-sm"
                  @click.prevent="viewFilterReport = false"
                >
                  <i class="fas fa-times"></i>
                </button>

                <button
                  type="button"
                  class="btn btn-secondary"
                  @click.prevent="limparFiltros()"
                >
                  {{ $t("Limpar Filtros") }}
                </button>
                <button
                  class="btn btn-success btn-submit"
                  data-style="zoom-in"
                  type="submit"
                >
                  <i class="fas fa-chart-bar"></i>
                  {{ $t("Filtrar") }}
                </button>
              </div>
            </div>
          </form>
        </div>

        <load mode="table" v-if="loading" message="Carregando Famílias" />
        <div v-else class="col-12">
          <print-content>
            <template v-slot:datas>
              <p class="d-flex align-items-center justify-content-between mb-4">
                <span
                  >Período selecionado:
                  <b>{{ datas.start }} - {{ datas.end }}</b>
                  <b-link
                    href="#"
                    @click.prevent="void 0"
                    class="mb-2"
                    variant="info"
                    v-b-popover.hover.top="
                      'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                    "
                  >
                    <i class="fas fa-info-circle"></i> </b-link
                ></span>

                <span v-if="pagination.total"
                  >Total de Registros <b>{{ pagination.total }}</b
                  >, total por página
                  <b>{{ pagination.perPage }}</b>
                </span>

                <span>
                  <a v-if="!showName" @click.prevent="mostrarNome" href="#"
                    ><i class="fas fa-eye"></i> Mostrar Nome de Registro</a
                  >
                  <a v-else @click.prevent="ocultarNome" href="#"
                    ><i class="fas fa-eye-slash"></i> Ocultar Nome de
                    Registro</a
                  >
                </span>
              </p>
            </template>
            <b-table
              :fields="[
                {
                  key: 'responsavel_familiar',
                  label: $t('Composição Familiar'),
                },
                {
                  key: 'endereco',
                  label: $t('Endereço'),
                },
                {
                  key: 'estado_cadastral',
                  label: $t('Estado Cadastral'),
                },
                {
                  key: 'cadastro',
                  label: $t('Datas'),
                },
                {
                  key: 'actions',
                  label: '',
                  class: 'text-right no-print',
                  thStyle: {
                    width: '95px',
                    minWidth: '95px',
                  },
                },
              ]"
              :items="familiasList"
              striped
              hover
              show-empty
              small
              outlined
              stacked="xs"
              table-class="mb-3"
            >
              <template v-slot:cell(responsavel_familiar)="data">
                RF:
                <span v-if="data.item.responsavel_familiar">
                  <strong
                    v-if="!data.item.responsavel_familiar.nome_social"
                    v-html="
                      $options.filters.highlight(
                        data.item.responsavel_familiar.nome_completo,
                        search
                      )
                    "
                  ></strong>
                  <span v-else>
                    <strong
                      v-if="showfiltroNomeSocial"
                      v-html="
                        $options.filters.highlight(
                          data.item.responsavel_familiar.nome_social,
                          filtroNomeSocial
                        )
                      "
                    ></strong>
                    <strong v-else>{{
                      data.item.responsavel_familiar.nome_social
                    }}</strong>
                    <strong>( N.R.: )</strong>
                    <strong
                      v-if="showName"
                      v-html="
                        $options.filters.highlight(
                          data.item.responsavel_familiar.nome_completo,
                          search
                        )
                      "
                    ></strong>
                  </span>
                </span>
                <span v-else>
                  <strong class="text-danger">FAMÍLIA SEM RESPONSÁVEL</strong>
                </span>
                <small class="d-block" v-if="data.item.responsavel_familiar">
                  <!-- <span v-if="data.item.data_nascimento">
                                            Idade:
                                             <br />
                                        </span> -->
                  Data de Nascimento:
                  <strong v-if="data.item.responsavel_familiar.data_nascimento">
                    {{
                      data.item.responsavel_familiar.data_nascimento
                        | formatDate
                    }}
                    <span v-if="data.item.responsavel_familiar.idade"
                      >({{ parseInt(data.item.responsavel_familiar.idade) }}
                      ano(s))
                    </span>
                  </strong>
                  <alert-icon v-else message="Data de Nascimento em branco" />
                  <br />

                  <span v-if="data.item.responsavel_familiar.documento">
                    CPF:
                    <strong
                      v-if="data.item.responsavel_familiar.documento.cpf"
                      v-html="
                        $options.filters.highlight(
                          data.item.responsavel_familiar.documento.cpf,
                          search
                        )
                      "
                    ></strong>

                    <alert-icon
                      v-if="
                        data.item.responsavel_familiar.documento.cpf == null
                      "
                      message="Não sabe o número do CPF ou não foi inserido no cadastro!"
                    />
                  </span>
                  <span v-else>
                    Documento:
                    <alert-icon
                      message="Pessoa sem documentação ou não foi inserido no cadastro!"
                    />
                  </span>
                  <br />
                  Filiação 1:
                  <strong>{{ data.item.responsavel_familiar.mae }}</strong>
                </small>

                <small class="d-block">
                  <b
                    >Composição familiar ({{
                      data.item.familiares_ativos.length
                    }})</b
                  >
                  <ul class="small" style="font-size: 10px">
                    <li
                      v-for="pessoa in getFamiliares(
                        data.item.responsavel_familiar.nome_completo,
                        data.item.familiares_ativos
                      )"
                      :key="pessoa.id"
                      v-html="
                        $options.filters.highlight(pessoa.nome_completo, search)
                      "
                    ></li>
                  </ul>
                </small>

                <small class="d-block" v-if="data.item.codigo_familiar"
                  ><span>Código CadÚnico: </span>
                  <strong
                    v-html="
                      $options.filters.highlight(
                        data.item.codigo_familiar,
                        search
                      )
                    "
                  ></strong>
                </small>
                <span class="d-block" v-else
                  ><span>ID: </span>
                  <strong
                    v-html="$options.filters.highlight(data.item.id, search)"
                  ></strong>
                </span>
                <!-- Alertas Baseados na lista outras_opcoes_filtro_familia em arrays.js-->
                <span class="d-block text-muted" v-if="filtroPerCapita">
                  <b-icon
                    icon="exclamation-triangle-fill"
                    variant="warning"
                    animation="fade"
                  ></b-icon>
                  <small v-if="data.item.financeiro">
                    Per capita:
                    {{
                      checkValue(data.item.financeiro.per_capita_familiar)
                    }}</small
                  >
                </span>

                <span
                  class="d-block text-muted"
                  v-if="data.item.trabalho_infantil == 1"
                >
                  <b-icon
                    icon="exclamation-triangle-fill"
                    variant="warning"
                    animation="fade"
                  ></b-icon>
                  <small>Trabalho infantil</small>
                </span>

                <span
                  class="d-block text-muted"
                  v-if="data.item.situacao_rua == 1"
                >
                  <b-icon
                    icon="exclamation-triangle-fill"
                    variant="warning"
                    animation="fade"
                  ></b-icon>
                  <small>Situação de rua</small>
                </span>

                <span class="d-block text-muted" v-if="data.item.migrante == 1">
                  <b-icon
                    icon="exclamation-triangle-fill"
                    variant="warning"
                    animation="fade"
                  ></b-icon>
                  <small>Família migrante</small>
                </span>

                <small
                  class="d-block text-muted"
                  v-if="
                    data.item.vulnerabilidades &&
                    data.item.vulnerabilidades.length > 0
                  "
                >
                  Vulnerabilidades
                  <ul>
                    <li
                      v-for="vulnerabilidade in data.item.vulnerabilidades"
                      :key="vulnerabilidade.id"
                    >
                      <strong>{{ vulnerabilidade.descricao | toUpper }}</strong>
                    </li>
                  </ul>
                </small>
              </template>
              <template v-slot:cell(endereco)="data">
                <div
                  class="small"
                  v-if="data.item.endereco && data.item.endereco.id != null"
                >
                  <span v-if="!data.item.endereco.situacao_rua">
                    <strong>
                      <span
                        v-html="
                          $options.filters.highlight(
                            data.item.endereco.logradouro.tipo_logradouro +
                              ' ' +
                              data.item.endereco.logradouro.nome_logradouro,
                            search
                          )
                        "
                      >
                      </span>
                    </strong>
                    -
                    {{ data.item.endereco.numero }}
                    <br />
                    <span
                      v-html="
                        $options.filters.highlight(
                          data.item.endereco.localidade,
                          search
                        )
                      "
                    >
                    </span>
                  </span>
                  <span v-else>
                    Endereço de Usuário/Família em Situação de Rua<br />
                    <strong
                      v-html="
                        $options.filters.highlight(
                          data.item.endereco.referencia_endereco,
                          search
                        )
                      "
                    >
                    </strong>
                  </span>
                </div>
                <div class="text-danger" v-else>
                  <strong>FAMÍLIA SEM ENDEREÇO</strong>
                </div>
              </template>
              <template v-slot:cell(estado_cadastral)="data">
                <span class="small" v-html="data.item.estado_cadastral"></span>
              </template>

              <template v-slot:cell(cadastro)="data">
                <span class="small text-muted d-block">
                  Criado em: {{ data.item.cadastro }}
                </span>
                <span class="small text-muted d-block"
                  >Atualizado em:
                  {{ data.item.atualizacao }}
                </span>
                <span
                  class="small text-muted d-block"
                  v-if="data.item.data_cadastramento"
                >
                  Cadastrado no Cadúnico em:
                  {{ data.item.data_cadastramento }}
                </span>
                <span
                  class="small text-muted d-block"
                  v-if="data.item.data_atualizacao"
                  >Atualizado no Cadúnico em:
                  {{ data.item.data_atualizacao }}
                  <b-link
                    v-if="data.item.alert_atualizacao_cadunico > 1"
                    href="#"
                    v-b-tooltip.hover
                    :title="`Atualizado há ${data.item.alert_atualizacao_cadunico} anos no Cadúnico`"
                  >
                    <b-icon
                      icon="exclamation-triangle-fill"
                      variant="warning"
                      animation="fade"
                    ></b-icon>
                  </b-link>
                </span>
              </template>

              <template v-slot:cell()="data">
                <b-button
                  :title="$t('Editar Família')"
                  :to="'/dashboard/familias/edit/' + data.item.id"
                  target="_blank"
                  class="px-2 mb-0"
                  size="sm"
                  type="button"
                  v-b-tooltip.hover
                  variant="success"
                >
                  <i class="fas fa-edit"></i>
                </b-button>

                <b-dropdown
                  no-caret
                  variant="info"
                  size="sm"
                  v-b-tooltip.hover
                  right
                  title="Serviços/Intervenções"
                >
                  <template #button-content>
                    <i class="fas fa-ellipsis-v"></i>
                  </template>
                  <b-dropdown-group id="dropdown-group-1" header="Intervenções">
                    <b-dropdown-item
                      :to="'/dashboard/atendimentos/' + data.item.id"
                      target="_blank"
                    >
                      Atendimentos
                    </b-dropdown-item>
                    <b-dropdown-item
                      :to="
                        '/dashboard/encaminhamentos/' +
                        data.item.id +
                        '?familia_id=' +
                        data.item.id
                      "
                      target="_blank"
                    >
                      Encaminhamentos
                    </b-dropdown-item>
                    <b-dropdown-item
                      :to="
                        '/dashboard/referenciamentos/' +
                        data.item.id +
                        '?familia_id=' +
                        data.item.id
                      "
                      target="_blank"
                    >
                      Referência e Contrarreferência
                    </b-dropdown-item>
                    <b-dropdown-item
                      :to="
                        '/dashboard/medidas/' +
                        data.item.id +
                        '?familia_id=' +
                        data.item.id
                      "
                      target="_blank"
                    >
                      Medidas Socioeducativas
                    </b-dropdown-item>
                    <b-dropdown-item
                      :to="
                        '/dashboard/acompanhamentos/' +
                        data.item.id +
                        '?familia_id=' +
                        data.item.id
                      "
                      target="_blank"
                    >
                      Acompanhamentos
                    </b-dropdown-item>
                    <b-dropdown-item
                      :to="
                        '/dashboard/violacaodedireitos/' +
                        data.item.id +
                        '?familia_id=' +
                        data.item.id
                      "
                      target="_blank"
                    >
                      Violação de Direitos
                    </b-dropdown-item>
                    <b-dropdown-item
                      :to="
                        '/dashboard/familia/acolhimentos/' +
                        data.item.id +
                        '?familia_id=' +
                        data.item.id
                      "
                      target="_blank"
                    >
                      Histórico de Acolhimentos
                    </b-dropdown-item>
                  </b-dropdown-group>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-group id="dropdown-group-2" header="Serviços">
                    <b-dropdown-item
                      :to="
                        '/dashboard/familia/beneficios/' +
                        data.item.id +
                        '?familia_id=' +
                        data.item.id
                      "
                      target="_blank"
                    >
                      Benefícios
                    </b-dropdown-item>
                    <b-dropdown-item
                      :to="
                        '/dashboard/programassociais/beneficiarios/' +
                        data.item.id +
                        '?familia_id=' +
                        data.item.id
                      "
                      target="_blank"
                    >
                      Programas Sociais
                    </b-dropdown-item>
                  </b-dropdown-group>
                </b-dropdown>
              </template>
              <template v-slot:empty="scope">
                <div class="text-center my-5">
                  <img
                    :alt="$t('No results')"
                    class="mb-5"
                    src="/img/icons/robot.svg"
                    style="max-height: 165px"
                  />
                  <h3 class="bold">
                    {{ $t("No records found") }}
                  </h3>
                </div>
              </template>
            </b-table>
          </print-content>
          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
              <div class="form-group d-inline-flex mb-0">
                <select
                  class="form-control"
                  style="width: 70px"
                  v-model="perPage"
                  v-on:change="getFamilias"
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="25">25</option>
                  <option value="100">100</option>
                </select>
              </div>
              <div class="d-inline-flex ml-2">
                <b-pagination
                  :per-page="perPage"
                  :total-rows="pagination.total"
                  @change="changePage"
                  v-model="page"
                />
              </div>
            </div>
            <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
              <div class="float-lg-right">
                {{ $t("Showing page") }}
                {{ pagination.currentPage }}
                {{ $t("of") }}
                {{ pagination.totalPages }}
                {{ $t("pages in") }}
                {{ pagination.total }}
                {{ $t("records") }}
              </div>
            </div>
          </div>

          <div class="box-btn-print no-print">
            <b-button
              v-if="!loading"
              :title="$t('Visualizar e Imprimir')"
              class="py-2"
              size="sm"
              type="button"
              v-b-tooltip.hover
              variant="primary"
              @click="print()"
            >
              <i class="fas fa-print"></i>
            </b-button>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
export default {
  name: "Familias",
  metaInfo() {
    return {
      title: this.$i18n.t("Gestão de Famílias"),
    };
  },
  data() {
    return {
      showName: false,
      page: 1,
      search: "",
      perPage: 10,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      familiasList: [],
      localidades: [],
      logradouros: [],
      loadingLocalidade: false,
      loadingLogradouro: false,
      datas: {},
      idades: null,
      filtroStatus: null,
      filtroDatas: [],
      filtroOutras: null,
      filtroLocalidade: null,
      filtroLogradouro: null,
      filtroPerCapita: false,
      composicao_familiar: true,
      showfiltroNomeSocial: false,
      filtroNomeSocial: "",
      filtroOrigemNomeSocial: [],
      filtroVulnerabilidades: [],
      vulnerabilidades: [],
      loadingVulnerabilidades: false,
      disableLogradouro: true,
    };
  },
  mounted() {
    this.getVulnerabilidades();
    this.getFamilias();
  },
  methods: {
    mostrarNome() {
      this.showName = true;
    },
    ocultarNome() {
      this.showName = false;
    },
    getFamiliares(rf, familiares) {
      return familiares.filter(function (elem) {
        return elem.nome_completo != rf;
      });
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getFamilias();
      }
    },
    getFamilias() {
      this.loading = true;

      this.datas.start = this.$options.filters.formatDate(this.data_inicio);
      this.datas.end = this.$options.filters.formatDate(this.data_fim);

      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      axios
        .get("api/dashboard/report/familias/home", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroStatus: this.filtroStatus,
            filtroDatas: this.filtroDatas,
            filtroOutras: this.filtroOutras,
            filtroLocalidade: this.filtroLocalidade,
            filtroLogradouro: this.filtroLogradouro,
            filtroNomeSocial: this.filtroNomeSocial,
            filtroOrigemNomeSocial: this.filtroOrigemNomeSocial,
            filtroVulnerabilidades: this.filtroVulnerabilidades,
          },
        })
        .then((response) => {
          this.filtroPerCapita = this.filtroOutras == 4 ? true : false;

          this.familiasList = response.data.dados;

          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getFamilias();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/report/familias/home", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroStatus: this.filtroStatus,
            filtroDatas: this.filtroDatas,
            filtroOutras: this.filtroOutras,
            filtroLocalidade: this.filtroLocalidade,
            filtroLogradouro: this.filtroLogradouro,
            filtroNomeSocial: this.filtroNomeSocial,
            filtroOrigemNomeSocial: this.filtroOrigemNomeSocial,
            filtroVulnerabilidades: this.filtroVulnerabilidades,
            export: "ok",
          },
        })
        .then((response) => {
          this.isLoadingMsg = false;
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          (this.isLoadingMsg = false), (this.loading = false);
        });
    },
    importarFamilias() {
      let ladda = Ladda.create(document.querySelector(".btn-importar"));
      ladda.start();
      axios.post("api/dashboard/familias/importar").then((response) => {
        ladda.stop();
        this.$snack.show({
          button: false,
          text: response.data.data.message,
        });
        ladda.stop();
      });
    },
    searchLocalidade: function searchLocalidade(search) {
      if (search != "") {
        clearTimeout(searchLocalidade.timeout);
        searchLocalidade.timeout = setTimeout(() => {
          this.loadingLocalidade = true;
          this.$refs.select.openOptions(false);
          axios
            .get(`api/dashboard/enderecos/pesquisar_bairro?q=${escape(search)}`)
            .then((response) => {
              this.localidades = response.data;
              this.$refs.select.openOptions(false);
            })
            .finally(() => {
              this.$refs.select.closeOptions(false);
              setTimeout(() => {
                this.loadingLocalidade = false;
                this.$refs.select.openOptions(true);
              }, 3000);
            });
        }, 1000);
      }
    },
    setLocalidade() {
      if (this.filtroLocalidade) {
        this.filtroLogradouro = null;
        setTimeout(() => {
          this.loadingLogradouro = true;
          this.setSelected(this.filtroLocalidade);
        }, 1000);
      }
    },
    setSelected(value) {
      if (value) {
        axios
          .get(
            `api/dashboard/enderecos/pesquisar_logradouro?localidade=${escape(
              value
            )}`
          )
          .then((response) => {
            this.logradouros = response.data;
            this.$refs.selectLogradouro.openOptions(true);
          })
          .finally(() => {
            this.loadingLogradouro = false;
            this.disableLogradouro = false;
          });
      }
    },
    searchLogradouro: function searchLogradouro(search) {
      if (search != "") {
        clearTimeout(searchLogradouro.timeout);
        searchLogradouro.timeout = setTimeout(() => {
          this.loadingLogradouro = true;
          this.$refs.selectLogradouro.openOptions(false);
          axios
            .get(
              `api/dashboard/enderecos/pesquisar_logradouro?logradouro_list_familia=${escape(
                search
              )}`
            )
            .then((response) => {
              this.logradouros = response.data;
              this.$refs.selectLogradouro.openOptions(false);
            })
            .finally(() => {
              this.$refs.selectLogradouro.closeOptions(false);
              setTimeout(() => {
                this.loadingLogradouro = false;
                this.$refs.selectLogradouro.openOptions(true);
              }, 3000);
            });
        }, 1000);
      }
    },
    checkValue(a) {
      a = parseFloat(a);
      return a.toLocaleString("pt-br", {
        minimumFractionDigits: 2,
        style: "currency",
        currency: "BRL",
      });
    },
    limparFiltros() {
      this.search = "";
      this.filtroStatus = null;
      this.filtroDatas = [];
      this.data_inicio = "";
      this.data_fim = "";
      this.filtroOutras = null;
      this.filtroOutras = null;
      this.filtroLocalidade = null;
      this.filtroLogradouro = null;

      this.showfiltroNomeSocial = false;
      this.filtroNomeSocial = "";
      this.filtroOrigemNomeSocial = [];

      this.filtroVulnerabilidades = [];

      this.getFamilias();
    },

    getVulnerabilidades() {
      this.loadingVulnerabilidades = true;
      axios
        .get(`api/dashboard/get/geral/vulnerabilidades`)
        .then((response) => {
          this.vulnerabilidades = response.data;
        })
        .finally(() => {
          this.loadingVulnerabilidades = false;
        });
    },
  },
};
</script>
